<div *ngIf="cmdbDatabase">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>storage</mat-icon>
      {{
        cmdbDatabase.id ? "Database - " + cmdbDatabase.name : "Create new Database"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="validatingCompany || companyValidationFailed || !form.form.valid || !cmdbDatabase.applicationId || !cmdbDatabase.environmentId || !cmdbDatabase.sqlServerTypeId || !cmdbDatabase.companyId"
      >
        <mat-icon>{{ cmdbDatabase.id ? "save" : "add" }}</mat-icon>
        {{ cmdbDatabase.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="cmdbDatabase.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded" style="display: inline-grid; grid-template-columns: auto;">
    <p *ngIf="companyValidationFailed">
      Unable to validate the selected records for this company.
      <button mat-button type="button" (click)="validateCompanySelections()">Retry</button>
    </p>
    <form #form="ngForm" role="form" style="margin-bottom: 1em;">
      <table class="basicTable vtable" style="width: 100%;">
        <thead>
          <tr>
            <th colspan="100">Database Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [companyId]="cmdbDatabase.companyId" (companyIdChange)="onCompanyChange($event)" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="DB Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="cmdbDatabase.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>Application</th>
            <td><micro-select-pagination apiUrl="/domain/cmdbApplications" [(id)]="cmdbDatabase.applicationId" [defaultOption]="selectedApplication" (objectChange)="selectedApplication = $event" placeholder="Application" routerBase="cmdbApplications" [params]="{companyId: cmdbDatabase.companyId}" [disabled]="validatingCompany || !cmdbDatabase.companyId" [required]="true"></micro-select-pagination></td>
          </tr>
          <tr>
            <th>Environment</th>
            <td><micro-environment-select [(environmentId)]="cmdbDatabase.environmentId" [companyId]="cmdbDatabase.companyId" [disabled]="validatingCompany || !cmdbDatabase.companyId" [required]="true"></micro-environment-select></td>
          </tr>
          <tr>
            <th><micro-valid-label for="sqlServerTypeId" [model]="sqlServerTypeId" label="SQL Server Type"></micro-valid-label></th>
            <td><micro-sql-type-select #sqlServerTypeId="ngModel" [(ngModel)]="cmdbDatabase.sqlServerTypeId" [required]="true" id="sqlServerTypeId" name="sqlServerTypeId"></micro-sql-type-select></td>
          </tr>
          <tr>
            <th>Description</th>
            <td>
              <textarea
                [(ngModel)]="cmdbDatabase.description"
                required
                maxlength="200"
                id="description"
                name="description"
                style="min-width: 350px; min-height: 100px;"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th [ngClass]="cmdbDatabase.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
              ></micro-valid-label>
            </th>
            <td>
              <input type="checkbox" [checked]="cmdbDatabase.active === 'Y'" (change)="onCheckboxChange($event)" id="active" name="active">
            </td>
          </tr>
        </tbody>
      </table>
    </form>
    <micro-cmdb-database-sql-servers [databaseId]="cmdbDatabase.id" [sqlServerTypeId]="cmdbDatabase.sqlServerTypeId"></micro-cmdb-database-sql-servers>
  </div>
</div>
